import img1 from "../src/img/chicken roll.jpg";
import img2 from "../src/img/egg Roll.jpg";
import img3 from "../src/img/chicken puff.jpg";
import img4 from "../src/img/tandoori-chicken-puff.jpeg";
import img5 from "../src/img/egg-puff.jpg";

const Rolldata ={
    cardData : [
  
             {
                id: 1,
                imgSrc:img1 ,
                title: 'Chicken Roll.',
                cont : 'Chicken Roll ,Egg Roll, Chicken Puff,Tandoori Chicken Puf  ,Egg Puff',
                 link : './Briyani',
                 rs : '40'
             },
             {
                 id: 2,
                 imgSrc:img2 ,
                 title: 'Egg Roll',
                 cont : 'Chicken Roll. ,Egg Roll, Chicken Puff, Tandoori Chicken Puf ,Egg Puff',
                 rs : '25'
              } ,
              {
                 id: 3,
                 imgSrc:img3 ,
                 title: 'Chicken Puff',
                 cont : 'Chicken Roll ,Egg Roll, Chicken Puff, Tandoori Chicken Puf,Egg Puff',
                 rs : '50'
               } ,
              {
                 id: 4,
                 imgSrc:img4,
                 title: 'Tandoori Chicken Puf',
                 cont : 'Chicken Roll , Egg Roll,Chicken Puff, Tandoori Chicken Puf,Egg Puff',
                 rs : '120'
              },
              {
                id: 5,
                imgSrc:img5 ,
                title: 'Egg Puff',  
                cont : 'Chicken Roll ,Egg Roll, Chicken Puff, Tandoori Chicken Puf ,Egg Puff',
                rs : '35'
             },
          
     ]
 };
 
 export default Rolldata;